import React, { ReactElement } from 'react';
import PngTemplateArt from './PngTemplateArt';
import startStopContinueImage from '../assets/template_start_stop_continue.png';

interface StartStopContinueArtProps {
  isDarkMode: boolean;
}

export default function StartStopContinueArt({ isDarkMode }: StartStopContinueArtProps): ReactElement {
  return <PngTemplateArt src={startStopContinueImage} isDarkMode={isDarkMode} />;
}
